<template>
  <b-container class="bv-example-row mt-3 createJoinRoomBox">
    <b-row>
      <b-col md="2" lg="3"></b-col>
      <b-col md="8" lg="6">
        <b-form @submit.prevent="createRoom()">
          <b-input-group v-if="showCreateRoomBox">
            <b-input-group-prepend>
              <b-button @click="toggleCreateRoomBox()" variant="warning">Cancel</b-button>
            </b-input-group-prepend>
            <b-form-input
              spellcheck="false"
              autocomplete="off"
              maxlength="25"
              v-model="roomName"
              :state="roomName.trim().length ? true : false"
              placeholder="Your room name"
              trim
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="createRoom()" variant="info">Create</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-button class="createNdJoinButton" @click="toggleCreateRoomBox()" v-else variant="primary">Create Room</b-button>
        </b-form>
      </b-col>
      <b-col md="2" lg="3"></b-col>
    </b-row>
  </b-container>
</template>
<script>
import store from "@/store";
import Server from "@/server";

export default {
  computed: {
    showCreateRoomBox: () => store.state.room.showCreateRoomBox
  },
  methods: {
    toggleCreateRoomBox: () => {
      store.state.room.showCreateRoomBox = !store.state.room.showCreateRoomBox;
      store.state.room.showjoinRoomBox = false;
    },
    createRoom: function() {
      if (!this.roomName.trim().length) return;
      this.toggleCreateRoomBox();
      Server.createBingoRoom(this.roomName);
    }
  },
  data: function() {
    return {
      roomName: ""
    };
  }
};
</script>
